import API from './API.js'

export default class ReadingType extends API {
  constructor() {
    super('reading-type')
  }
}
